import {isStaff, isTeacher} from './commonHelpers.js';

export function getValidSchoolsOptions({schools}) {
  let schoolNames = [];

  for (const id in schools) {
    if (!schools.hasOwnProperty(id)) {
      continue;
    }

    const schoolName = {
      id: id,
      name: schools[id].name
    };

    schoolNames = [...schoolNames, schoolName];
  }

  return schoolNames;
}

export function getValidPeopleOptions({staffs, teachers, schools}, schoolId) {
  if (schools[schoolId] === undefined) {
    throw new Error('Invalid school id: ' + schoolId);
  }

  const schoolStaffs = schools[schoolId].staffs;
  const schoolTeachers = schools[schoolId].teachers;

  const staffsOptions = schoolStaffs.map(staffId => ({
    id: staffId,
    name: staffs[staffId]
  }));

  const teachersOptions = schoolTeachers.map(teacherId => ({
    id: teacherId,
    name: teachers[teacherId]
  }));

  return {staffs: staffsOptions, teachers: teachersOptions};
}

export function getValidToolsOptions(
    {staffTools, teacherTools, schools, teachers, staffs},
    personId,
    state
) {
  const selectedSchoolId = state.schools.selected;

  const schoolTeacherTools = schools[selectedSchoolId].teacherTools;
  const schoolStaffTools = schools[selectedSchoolId].staffTools;

  let toolsOptions = {};

  if (isTeacher(personId)) {
    for (const toolTypeId in schoolTeacherTools) {
      if (!schoolTeacherTools.hasOwnProperty(toolTypeId)) {
        continue;
      }

      const tools = schoolTeacherTools[toolTypeId];

      toolsOptions[toolTypeId] = tools.map(tool => ({
        id: tool,
        name: teacherTools[tool]
      }));
    }
  } else if (isStaff(personId)) {
    for (const toolTypeId in schoolStaffTools) {
      if (!schoolStaffTools.hasOwnProperty(toolTypeId)) {
        continue;
      }

      const tools = schoolStaffTools[toolTypeId];

      toolsOptions[toolTypeId] = tools.map(tool => ({
        id: tool,
        name: staffTools[tool]
      }));
    }
  }

  return toolsOptions;
}

export function getValidDepartmentsOptions({schools, departments}, personId, state) {
  const selectedSchoolId = state.schools.selected;
  const schoolDepartments = schools[selectedSchoolId].departments;

  return schoolDepartments.map(schoolDepartmentId => ({
    id: schoolDepartmentId,
    name: departments[schoolDepartmentId]
  }));
}

export function getValidGradesOptions({schools, grades}, personId, state) {
  const selectedSchoolId = state.schools.selected;
  const schoolGrades = schools[selectedSchoolId].grades;

  return schoolGrades.map(schoolGradeId => ({
    id: schoolGradeId,
    name: grades[schoolGradeId]
  }));
}
